<div class="card-container" *ngIf="videoData">
  <img [src]="videoData.thumbnailUrl"/>

  <div class="watched-marker">
    <ng-container *ngIf="videoData.watched; else notWatched">
      <app-pill [type]="ePillType.GREEN">
        <span class="fal fa-fw fa-check"></span>
        <strong>WATCHED</strong>
      </app-pill>
    </ng-container>
    <ng-template #notWatched>
      <app-pill [type]="ePillType.YELLOW">
        <span class="fal fa-fw fa-sparkles"></span>
        <strong>NEW</strong>
      </app-pill>
    </ng-template>
  </div>

  <div class="video-metadata">
    <span class="video-title">{{videoData.title}}</span>
    <span class="video-info">
      <span class="fal fa-fw fa-info-circle" [tooltip]="cardTooltip" placement="bottom" container="body" [triggers]="globals.tooltipTriggers" *ngIf="videoData.description"></span>
      <ng-template #cardTooltip>
        <div class="p-5 text-left">
          <div>
            <span>{{videoData.description}}</span>
          </div>
          <div class="text-left p-top-5">
            <ng-container *ngFor="let feature of videoData.features">
              <div class="p-bottom-5">
                <app-pill>
                  <strong>{{feature | underscoreToSpace}}</strong>
                </app-pill>
              </div>
            </ng-container>
            <ng-container *ngIf="videoData.accessLevel">
              <div class="p-bottom-5">
                <app-pill [type]="ePillType.BLUE">
                  <strong>{{videoData.accessLevel.name| underscoreToSpace}}</strong>
                </app-pill>
              </div>
            </ng-container>
          </div>
        </div>
      </ng-template>
    </span>
  </div>
</div>